import styled from "styled-components";
import { SIDE_BAR_WIDTH, TOP_NAV_HEIGHT } from "../../constants";
import HeaderBannerPng from "./../../icons/headerBanner.png";

export const StyledClientDetail = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Banner = styled.div`
  height: 248px;
  width: calc(100vw - ${SIDE_BAR_WIDTH});
  min-width: 1160px;
  box-sizing: border-box;
  background: url(${HeaderBannerPng});
  color: #ffffff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 116px 68px 0px 68px;
  z-index: 3;
  position: fixed;
`;

export const ClientName = styled.div`
  font-size: 36px;
  font-weight: 700;
  letter-spacing: -0.23px;
  margin-bottom: 2px;
`;

export const ClientDetailContent = styled.div`
  display: flex;
  padding: 300px 70px 40px;
`;

export const MainContent = styled.div`
  min-width: 905px;
  max-height: calc(100vh - ${TOP_NAV_HEIGHT} - 168px - 80px);
  overflow: scroll;
`;

export const RightNav = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e3e3f2;
  max-height: 144px;
  min-width: 216px;
`;

const defaultActionStyles = `
  padding-left: 30px;
  display: flex;
  align-items: center;
  color: #5d69e6;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.39px;
  line-height: 36px;
  cursor: pointer;

  svg {
    margin-right: 20px;
  }
`;

export const Action = styled.div`
  ${defaultActionStyles}
`;

export const DownloadLinkAction = styled.a`
  ${defaultActionStyles}

  // Extra styles for the download link since it's an anchor element
  text-decoration: none;
  text-align: center;
`;

export const FeedHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  // So that the divider stops where the list stops since the
  // list takes all but 25px up
  margin-right: 25px;
  padding-bottom: 16px;
`;

export const ActiveFeedHeader = styled.div`
  min-width: 110px;
  font-family: HelveticaNeue;
  font-size: 18px;
  margin-right: 12px;
`;

export const InactiveFeedHeader = styled(ActiveFeedHeader)`
  min-width: 125px;
`;
